import {CoinsSections_MissionSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import {SPACING, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {CoinsMission} from './CoinsMission';

export const CoinsMissions: React.FC<CoinsSections_MissionSection> = ({
  title,
  description,
  missions,
}) => {
  return (
    <Wrapper data-testid="coinsMissions">
      <TitleWrapper>
        <Text size="px16" weight="mediumHeavy">
          {title}
        </Text>
        <Text size="px12" color="Text.Grey">
          {description}
        </Text>
      </TitleWrapper>

      {missions.map((mission, index) => (
        <CoinsMission key={index} {...mission} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: ${SPACING['Y.Md']};
  gap: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${SPACING['Y.Lg']} 0;
  gap: 4px;
`;
